import { Route, Routes } from 'react-router-dom';
import PageNotFound from '../pages/ErrorPage/PageNotFound';
import PrivateRoute from './PrivateRoute';
import DashboardLayout from '../layouts/DashboardLayout';
import {
  PermissionRequired,
  AccessControl,
  //@ts-ignore
} from '@careinfo/permission-required';
import {
  SupportRouterService,
  SubjectRouterService,
  NoticeRouterService,
  //@ts-ignore
} from '@careinfo/support';
import Support from '../pages/Support';
//@ts-ignore
import { WelcomeRouterService } from '@careinfo/welcome-page-service';
import { getKey } from '../helpers/sessionKey';

const Router = () => {
  const shouldShowWelcome = getKey('shouldShowWelcome');
  return (
    <Routes>
      <Route
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        <Route
          path={'/support'}
          element={
            shouldShowWelcome === 'true' || shouldShowWelcome === null ? (
              <WelcomeRouterService />
            ) : (
              <Support />
            )
          }
        />
        <Route path={'/support/overview'} element={<Support />} />
        <Route path={'/support/notice'} element={<NoticeRouterService />} />
        <Route
          path={'/support/ticket'}
          element={
            <AccessControl
              children={<SupportRouterService />}
              allowedPermissions={['can_view_ticket']}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={'/support/subject'}
          element={
            <AccessControl
              children={<SubjectRouterService />}
              allowedPermissions={['can_view_ticket']}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route path='/*' element={<PageNotFound />} />
      </Route>
    </Routes>
  );
};

export default Router;
